// extracted by mini-css-extract-plugin
module.exports = {"root":"MantineTabs_root__iK8_b","list":"MantineTabs_list__RfM3v","tab":"MantineTabs_tab__wBdvB","tabLabel":"MantineTabs_tabLabel__K21K_"};